import React from 'react'
import { FilterName, FilterParam } from '../FilterBar.types'
import { GenericFilterDropdown } from './GenericFilterDropdown'

export const AuditFrameworksFilterDropdown = React.memo(
  ({ isNested = false }: { isNested?: boolean }): JSX.Element => {
    return (
      <GenericFilterDropdown
        filterParam={FilterParam.AUDIT_FRAMEWORKS}
        filterName={FilterName.AUDIT_FRAMEWORKS}
        valueKey="audit_frameworks"
        isNested={isNested}
      />
    )
  },
)
